// Firebase configuration – Auth + Firestore
//
// Default values below match the project's Firebase config.
// Env vars (injected by webpack DefinePlugin in CI) override when set.

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Use the current hostname as authDomain when it's an authorized domain,
// so signInWithPopup works without cross-domain cookie issues.
// Falls back to the default firebaseapp.com domain for unknown hosts.
const AUTHORIZED_DOMAINS = ['localhost', 'eyefitness.ca', 'eyes-trainer-dae26.firebaseapp.com', 'eyes-trainer-dae26.web.app'];
const detectedAuthDomain = typeof window !== 'undefined' && AUTHORIZED_DOMAINS.includes(window.location.hostname)
    ? window.location.hostname
    : 'eyes-trainer-dae26.firebaseapp.com';

const firebaseConfig = {
    apiKey:            process.env.FIREBASE_API_KEY             || "AIzaSyD5BQugHhu7JhOezj7jCiK853QSUlB-ajM",
    authDomain:        process.env.FIREBASE_AUTH_DOMAIN         || detectedAuthDomain,
    projectId:         process.env.FIREBASE_PROJECT_ID          || "eyes-trainer-dae26",
    storageBucket:     process.env.FIREBASE_STORAGE_BUCKET      || "eyes-trainer-dae26.firebasestorage.app",
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "1045633568423",
    appId:             process.env.FIREBASE_APP_ID              || "1:1045633568423:web:abf9787bfe09bfe061d582",
    measurementId:     process.env.GA_TRACKING_ID               || "G-EDKL4CRP8E",
};

// Check if Firebase is actually configured (env vars provided at build time)
export const isFirebaseConfigured = !!(firebaseConfig.apiKey && firebaseConfig.projectId);

let app = null;
let auth = null;
let googleProvider = null;
let db = null;

if (isFirebaseConfigured) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
    db = getFirestore(app);
}

export { auth, googleProvider, db };
export default app;
